export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return ""
  const digits = phone.replace(/\D/g, "")
  if (digits === "") return phone
  if (
    digits.length === 11 &&
    (digits.startsWith("7") || digits.startsWith("8"))
  ) {
    return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`
  }
  if (digits.length === 10) {
    return `+7 ${digits.slice(0, 3)} ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`
  }
  return phone.startsWith("+") ? phone : `+${digits}`
}

export function shortId(id: string | null | undefined): string {
  if (!id) return ""
  return id.slice(0, 8)
}

export function formatCompactClientOption(
  client: { name: string; isAuthorized?: boolean } | null | undefined,
  maxLength = 40,
): string {
  if (!client) return ""
  const authSuffix = client.isAuthorized === false ? " (не авторизован)" : ""
  const full = `${client.name}${authSuffix}`
  if (full.length <= maxLength) {
    return full
  }
  return full.slice(0, maxLength - 1) + "…"
}
